<div class="Padre">
  <div style="background-color: #2d6df6">
    <br />
    <div class="desktop">
      <banner-app
        [Fixtop]="''"
        [retroSelected]="true"
        [Loader]="true"
        [showPromo]="true"
      ></banner-app>
      <br /><br />
      <div class="img-contenedora">
        <app-webm-player
          src="./assets/img/motoAnimation.webm"
          alt="Seguro de moto"
          width="30%"
          height="auto"
          cssClass="w-90"
        />
      </div>
      <div class="mensajeLoading img-contenedora">
        {{ this.nombreCliente }}, estamos preparando las mejores<br />
        opciones para tu seguro
      </div>
    </div>
    <div class="mobile">
      <br /><br />
      <div class="img-contenedora">
        <br /><br /><br /><br />
        <app-webm-player
          src="./assets/img/motoAnimation.webm"
          alt="Seguro de moto"
          width="90%"
          height="auto"
          cssClass="w-90"
        />
      </div>
      <div class="mensajeLoading">
        {{ this.nombreCliente }}, estamos preparando las mejores opciones<br />
        para tu seguro
      </div>
    </div>
  </div>
</div>
